/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesUsers.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for User Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:58 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const Users = Loadable({
    loader: () => import('../containers/Users/UserListContainer'),
    loading: Loading,
});

export const UserEdit = Loadable({
    loader: () => import('../containers/Users/UserEditContainer'),
    loading: Loading,
});

export const UserStatuses = Loadable({
    loader: () => import('../containers/UserStatuses/UserStatusListContainer'),
    loading: Loading,
});

export const UserStatusEdit = Loadable({
    loader: () => import('../containers/UserStatuses/UserStatusEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesUsers.js